import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { NavigationStart, Router } from "@angular/router";
import Keycloak from 'keycloak-js';
import { LocalStorageService } from "ngx-webstorage";
import { environment } from "../../../environments/environment";
import { JsonResponse } from "@core_interfaces/JsonResponse.interface";
import {PermissionAccessService} from "@pages/permissions/services/permission-access.service";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private _authenticated = false;

    private _keycloak: Keycloak;

    private _router = inject(Router);
    private _http = inject(HttpClient);
    private _localStorage = inject(LocalStorageService);
    private _permissionAccessService = inject(PermissionAccessService);

    constructor() {
        this._authenticated = !!this._localStorage.retrieve('session_token');

        this._router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {

                if (!event.url.includes('/auth')) {
                    this._localStorage.store('latest_url', event.url);
                }

            }
        })
    }

    get authenticated() {
        return this._authenticated;
    }

    public async checkSsoLogin() {
        this._keycloak = new Keycloak({
          url: "https://keycloak.re18.tech",
          realm: "Re18",
          clientId: "revolab-dashboard"
        });
        const ssoAuthenticated = await this._keycloak.init({
            checkLoginIframe: false,
            flow: 'hybrid'
        });
        if (ssoAuthenticated) {
            const params = {
                "access_token": this._keycloak.token,
                "id": this._keycloak.idTokenParsed.sub,
                ...this._keycloak.tokenParsed
            }

            this._login(params);

        }
    }

    public async ssoLogin() {
        await this._keycloak.login({
          "redirectUri": environment.siteUrl + "/auth-sso"
        })
    }

    private _login(params: any): void {

        this._http.post<JsonResponse<any>>('/loginRe18', { ...params }).subscribe(res => {
            if (res.success) {

                this._localStorage.store('session_token', res.data.sessionToken);

                this._authenticated = true;

                this._permissionAccessService.getAuthUserPermissions();

                this._router.navigate([this._localStorage.retrieve('latest_url') || '/']);

            } else {
                this._router.navigate(['/auth-sso']);
            }
        })
    }

    public logout(): void {
        // preserve these from delettion
        const latest_url = this._localStorage.retrieve('latest_url');
        const theme = this._localStorage.retrieve('theme');

        this._localStorage.clear();

        this._localStorage.store('latest_url', latest_url);
        this._localStorage.store('theme', theme);

        this._authenticated = false;

        this._router.navigate(['/auth']);
    }

}
